import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Shift completed');
})
class CreateShiftCompleted extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="view-shift-completed">
                <div className="bg-img"></div>
                <div className="view-content maxwidth-wrapper">
                    <img className="" src={require('../styles/images/vasterbotten-at-night.png')} alt="" />

                    <h1>Done! Your shift is now ready.</h1>

                    <div className="buttons">
                        <Link to="shift" params={{shiftId: parseInt(this.props.params.shiftId)}} className="btn btn-green">View now</Link>
                        <Link to="agenda" className="btn btn-dashboard">Go to dashboard</Link>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreateShiftCompleted;



/** WEBPACK FOOTER **
 ** ./app/src/views/CreateShiftCompleted.js
 **/